<style>
    .v-select .dropdown-toggle  {
        height:50px;
    }

    .v-select.open .selected-tag {
        margin-top:12px;
    }

    .v-select .selected-tag {
        color: #7a7876 !important;
    }

    .v-select .dropdown-toggle .vs__actions .clear {
        display: none;
    }

    .v-select .dropdown-toggle {
        border-radius:0px;
    }

    .v-select {
        border: 1px solid #d5d5d5;
    }

    .v-select .open-indicator {
        width:20px;
    }


</style>

<template>
    <div class="wpb_content specify">
        <div class="specify-content">
            <h2>SPECIFICEREN</h2>
            <p>{{category.title}}</p>
            <form action="" class="specify-form">
                <div class="specify-form-row clearfix">
                    <div class="form-label lg-select">
                        <strong>STAAL</strong>
                        <v-select class="v-select" v-model="activeSteel" :options="steels" :searchable="false">

                        </v-select>

                    </div>
                    <div class="form-label lg-select" style="padding-top: 25px;">
                        <strong>VORM</strong>
                        <v-select class="v-select" label="name" v-model="shape" placeholder="Vorm" :options="shapeOptions" :searchable="false">

                        </v-select>

                    </div>
                    <div class="form-label md-select" style="padding-top: 25px;">
                        <strong>AANTAL</strong>
                        <v-select class="v-select" v-model="amount" :options="amountOptions" :searchable="false"></v-select>
                    </div>
                </div>
                <div class="form-label" style="padding-top:25px;">
                    <div class="specify-form-row clearfix">

                        <div class="md-select">
                            <strong v-if="! diameter">BREEDTE</strong>
                            <v-select v-if="! diameter" class="v-select" label="width" v-model="width" :options="widthOptions" placeholder="Breedte" :searchable="true"></v-select>
                        </div>
                        <div class="md-select">
                            <strong>DIKTE</strong>
                            <v-select v-if="! diameter" class="v-select" label="thickness" v-model="thickness" v-bind:disabled=" this.width == '' " :options="thicknessOptions" placeholder="Dikte"></v-select>
                            <v-select v-if="diameter" class="v-select" label="thickness" v-model="thickness" v-bind:disabled=" this.width == '' " :options="thicknessOptions" placeholder="Diameter"></v-select>
                        </div>
                        <div class="md-select">
                            <strong>LENGTE</strong>
                            <v-select class="v-select" label="length" v-model="length" :options="lengthOptions" v-bind:disabled=" this.thickness == '' " placeholder="Lengte"></v-select>

                        </div>
                    </div>
                </div>

            </form>
        </div>
        <aside class="right-sidebar">
            <div class="right-bar-inner">
                <div class="right-bar-section heading-area">
                    <p class="code">
                        {{activeSteel.name}}
                    </p>
                    <p class="heading">{{activeSteel.type}}</p>
                </div>
                <div class="right-bar-section">
                    <h6>MAAT</h6>
                    <p v-if="length"><span>Lengte</span><span>{{length}} mm</span></p>
                    <p v-if="width && ! diameter"><span>Breedte</span><span>{{width}} mm</span></p>
                    <p v-if="thickness"><span>{{diameter ? "Diameter" : "Dikte"}}</span><span>{{thickness}} mm</span></p>
                </div>
                <div class="right-bar-section">
                    <h6>VORM & AANTAL</h6>
                    <p><span>Vorm</span><span>{{shape.name}}</span></p>
                    <p>
                        <span>Aantal</span>
                        <span v-show="amount == 1">{{amount}} stuk</span>
                        <span v-show="amount > 1">{{amount}} stuks</span>
                    </p>
                </div>
                <div class="right-bar-section position-value">
                    <p v-if="product"><span>Aantal</span>
                        <span class="value" v-if="product" v-show="amount == 1">{{amount}} stuk</span>
                        <span class="value" v-if="product" v-show="amount > 1">{{amount}} stuks</span>
                    </p>
                    <p v-if="product"><span>Stukprijs</span><span class="value" v-if="product">&euro;{{parseFloat(product.price * amount).toFixed(2)}}</span></p>
                    <p v-if="product"><span>Korting <small class="small ex_btw">({{parseFloat(customer.discount_percentage).toFixed(0)}}%)</small></span><span class="value" v-if="product">&euro;{{((parseFloat(product.price * amount).toFixed(2) / 100) * parseFloat(customer.discount_percentage).toFixed(0)).toFixed(2)}}</span></p>
                    <p v-if="product"><span>Totaal <small class="small_ex_btw">(exclusief BTW)</small></span><span class="value" v-if="product">&euro;{{(parseFloat(product.price * amount).toFixed(2) - (parseFloat(product.price * amount).toFixed(2) / 100) * parseFloat(customer.discount_percentage).toFixed(0)).toFixed(2)}}</span></p>
                </div>
            </div>
            <button class="specify-btn" v-bind:disabled="! product || posting" @click="postItemOrder()">IN WINKELMAND</button>
            <button class="specify-btn-blue popup-btn" v-bind:disabled="! product || posting" @click="postItemOffer()">OFFERTE</button>
        </aside>
    </div>
</template>

<script>

    import vSelect from 'vue-select'

    var SortedArray = require("collections/sorted-array");

    export default {
        props: [
            'steels',
            'steel',
            'category',
            'products',
            'shapes',
            'orderLine',
            'customer'
        ],
        components: {
            'v-select': vSelect
        },
        beforeCreate: function() {

        },
        data: function() {
            return {
                shape: "",
                shapeOptions: [],
                activeSteel: this.steel,

                amount: 1,
                amountOptions: [],

                length: "",
                width: "",
                thickness: "",

                product: null,
                diameter: false,
                posting: false,

                orderOrOffer: 0 // Order == true (1) ||||||| Offer == false (0);
            }
        },
        created: function() {
            for(var i = 1; i <= 10; i++) {
                this.amountOptions.push(i);
            }
        },
        mounted: function() {

            let _this = this;
            Object.keys(this.shapes).forEach(function(key) {

                //Set the selected shape from the orderline when the user wants to edit the product from the cart

                _this.shapeOptions.push(_this.shapes[key]);
            }, _this);

            //If there is no orderline set the first shape of the array as the active shape.
            (this.orderLine === undefined) ? this.shape = this.shapeOptions[0] : this.setSelectedValuesFromOrderLine();

        },
        methods: {
            setSelectedValuesFromOrderLine: function(){

                let _this = this;

                _this.shape = _this.orderLine.shape;
                setTimeout(function(){
                    _this.length = _this.orderLine.length;
                    setTimeout(function(){
                        _this.width = _this.orderLine.width;
                        _this.amount = _this.orderLine.pieces;
                        setTimeout(function(){
                            _this.thickness = _this.orderLine.thickness;
                        },100);
                    },100);
                },100);

            },
            setProduct: function() {
                let _this = this;

                let product = this.products.filter(function(value, key){
                    if(
                        value.steel_id == _this.activeSteel.id
                        && value.shape_id == _this.shape.id
                        && value.length == _this.length
                        && value.width == _this.width
                        && value.thickness == _this.thickness) {
                        return value;
                    }
                }, _this);

                this.product = product[0];
            },
            postItemOffer: function() {
                this.orderOrOffer = 0;
                this.postItem();
            },
            postItemOrder: function() {
                this.orderOrOffer = 1;
                this.postItem();
            },
            postItem: function() {
                this.posting = true;

                let url = '/order-line/store';

                if(this.orderLine !== undefined){
                    url = '/order-line/update/' + this.orderLine.id;
                }

                let _this = this;
                axios.post(url, {
                    product: this.product.id,
                    category: this.category.id,
                    amount: this.amount,
                    shape: this.shape.code,
                    orderOrOffer: this.orderOrOffer,
                    free: false,
                })
                .then(function (response) {
                    _this.posting = false;
                    _this.$awn.success("Uw product is toegevoegd aan de winkelwagen!");
                    if(_this.orderLine === undefined){
                        window.incrementShoppingCart();
                    }
                }, _this)
                .catch(function (error) {
                    _this.posting = false;
                    _this.$awn.alert("Oeps, daar ging iets mis, probeert u het later nog eens");
                }, _this);
            },
            changeShapes: function(){
                let _this = this;

                axios.post('/change-shape/' + this.activeSteel.slug)
                    .then(function (response) {

                        _this.shapeOptions = Array.from(response.data.shapes);
                        _this.shape = _this.shapeOptions[0];
                        _this.posting = false;

//                         TODO: @Cas.. Hier geen melding?
//                        _this.$awn.success("Uw product is toegevoegd aan de winkelwagen!");

                    }, _this)
                    .catch(function (error) {
                        _this.posting = false;
                        _this.$awn.alert("Oeps, daar ging iets mis, probeert u het later nog eens");
                    }, _this);
            }
        },
        computed: {
            widthOptions: function () {
                let _this = this;

                let widthProducts = this.products.filter(function(value, key){
                    if(value.shape_id == _this.shape.id
                        && value.steel_id == _this.activeSteel.id) {
                        return value.width;
                    }
                }, _this);

                let unique = [...new Set(widthProducts.map(item => item.width))]
                    .sort((a,b) => a - b);

                return unique;
            },
            thicknessOptions: function() {
                let _this = this;

                let thicknessProducts = this.products.filter(function(value, key){
                    if(value.shape_id == _this.shape.id
                        && value.width == _this.width
                        && value.steel_id == _this.activeSteel.id) {
                        return value.thickness;
                    }
                }, _this);

                let unique = [...new Set(thicknessProducts.map(item => item.thickness))]
                    .sort((a,b) => a - b);

                return unique;
            },
            lengthOptions: function () {
                let _this = this;

                let lengthProducts = this.products.filter(function(value, key){
                    if(value.shape_id == _this.shape.id
                        && value.thickness == _this.thickness
                        && value.width == _this.width
                        && value.steel_id == _this.activeSteel.id) {
                        return value.length;
                    }
                }, _this);

                let unique = [...new Set(lengthProducts.map(item => item.length))]
                    .sort((a,b) => a - b);

                if(unique.length == 1) {
                    //this.length = unique[0];
                }

                return unique;
            }
        },
        watch: {
            activeSteel: {
                handler: function(val) {
                   this.changeShapes();
                }
            },
            shape: {
                handler: function(val) {
                    this.length = '';
                    this.amount = 1;
                    if(this.shape.code == "R") {
                        this.diameter = true;
                        this.length = this.lengthOptions[0];
                        this.width = "0.00";
                    } else {
                        this.diameter = false;
                        this.length = "";
                        this.width = "";
                    }
                }
            },
            width: {
                handler: function(val) {
                    this.thickness = '';
                }
            },
            thickness: {
                handler: function(val) {
                    this.length = '';
                }
            },
            length: {
                handler: function(val) {
                    this.setProduct();
                }
            },
            widthOptions: {
                handler: function(val) {
                    if(val.length == 1) {
                        if(val[0] == "0.00") {
                            this.diameter = true;
                            this.width = "0.00";
                        }
                    } else {
                        this.diameter = false;
                    }
                }
            },
            orderLine: {
                handler: function(val) {
                    this.setSelectedValuesFromOrderLine();
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/product/specificeren.vue